import { useLocation, useNavigate } from 'react-router-dom'

import Login from './Login'
import { useLogin } from '../../services/users/useUser'
import { LoginApiRequest } from '../../types/user/types'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingOverlay } from '../../components/Loading'
import { useShowNotification } from '../../hooks/useShowNotificationContext'

export const LoginContainer = () => {
  const navigate = useNavigate()
  const { mutate, isPending } = useLogin()
  const { showSucessNotification, showErrorNotification } = useShowNotification()
  const { login } = useAuth()
  const location = useLocation();

  const from = location.state?.from?.pathname;

  const route = from?.startsWith("/tickets/feedback/") ? from : "/home";

  const onLoginFormSubmit = (formData: LoginApiRequest) => {
    mutate(formData, {
      onSuccess: (data) => {
        if (data?.token && data?.oidCliente) {
          login(data)
          showSucessNotification("Login realizado com sucesso! Bem-vindo(a) ao sistema.");
          navigate(route, { replace: true });
        }
      },
      onError: (e) => {
        showErrorNotification(e, 'Falha no login: verifique suas credenciais e tente novamente.');
      },
    })
  }

  return (
    <>
      {isPending && <LoadingOverlay />}

      <Login onLoginFormSubmit={onLoginFormSubmit} />
    </>
  )
}
